import React from 'react';
import { Save, Upload } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
export function AdminSettings() {
  return <div className="max-w-3xl" data-id="element-327">
      <div className="flex justify-between items-center mb-8" data-id="element-328">
        <div data-id="element-329">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-330">
            Configurações da Marca
          </h1>
          <p className="text-gray-500" data-id="element-331">
            Personalize a aparência do app para seus alunos.
          </p>
        </div>
        <Button leftIcon={<Save size={18} data-id="element-333" />} data-id="element-332">Salvar Alterações</Button>
      </div>

      <div className="space-y-6" data-id="element-334">
        <Card data-id="element-335">
          <h3 className="font-bold text-gray-900 mb-6" data-id="element-336">Identidade Visual</h3>

          <div className="grid gap-6" data-id="element-337">
            <div data-id="element-338">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-339">
                Logo da Academia
              </label>
              <div className="flex items-center gap-4" data-id="element-340">
                <div className="h-20 w-20 bg-gray-100 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-300" data-id="element-341">
                  <Upload size={24} className="text-gray-400" data-id="element-342" />
                </div>
                <Button variant="outline" size="sm" data-id="element-343">
                  Carregar Logo
                </Button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-344">
              <div data-id="element-345">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-346">
                  Cor Primária (Destaque)
                </label>
                <div className="flex items-center gap-2" data-id="element-347">
                  <div className="w-10 h-10 rounded-lg bg-[#FF6B35] shadow-sm border border-gray-200" data-id="element-348"></div>
                  <input type="text" value="#FF6B35" className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm" data-id="element-349" />
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-350">
                  Usada em botões e chamadas de ação.
                </p>
              </div>

              <div data-id="element-351">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-352">
                  Cor Secundária (Base)
                </label>
                <div className="flex items-center gap-2" data-id="element-353">
                  <div className="w-10 h-10 rounded-lg bg-[#2D3748] shadow-sm border border-gray-200" data-id="element-354"></div>
                  <input type="text" value="#2D3748" className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm" data-id="element-355" />
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-356">
                  Usada em cabeçalhos e textos principais.
                </p>
              </div>
            </div>

            <div data-id="element-357">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-358">
                Nome da Academia
              </label>
              <input type="text" value="Iron Gym" className="w-full border border-gray-300 rounded-lg px-3 py-2" data-id="element-359" />
            </div>
          </div>
        </Card>

        <Card data-id="element-360">
          <h3 className="font-bold text-gray-900 mb-4" data-id="element-361">Preview do App</h3>
          <div className="bg-gray-100 p-8 rounded-xl flex justify-center" data-id="element-362">
            <div className="w-64 h-[500px] bg-white rounded-3xl shadow-xl border-4 border-gray-800 overflow-hidden relative" data-id="element-363">
              {/* Mock Mobile Screen */}
              <div className="bg-[#2D3748] p-4 text-white" data-id="element-364">
                <div className="text-xs font-bold" data-id="element-365">Iron Gym</div>
              </div>
              <div className="p-4" data-id="element-366">
                <div className="h-32 bg-gradient-to-br from-[#2D3748] to-gray-800 rounded-xl mb-4 relative overflow-hidden" data-id="element-367">
                  <div className="absolute bottom-0 left-0 w-16 h-16 bg-[#FF6B35] opacity-20 blur-xl rounded-full" data-id="element-368"></div>
                </div>
                <div className="flex gap-2 mb-4" data-id="element-369">
                  <div className="flex-1 h-20 bg-gray-50 rounded-lg border border-gray-100" data-id="element-370"></div>
                  <div className="flex-1 h-20 bg-gray-50 rounded-lg border border-gray-100" data-id="element-371"></div>
                </div>
                <div className="w-full h-10 bg-[#FF6B35] rounded-lg" data-id="element-372"></div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}